import { c as _c } from "react/compiler-runtime";
export type LogoProps = React.HTMLAttributes<SVGElement>;
export const Logo = props => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p>S</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};